import { render, staticRenderFns } from "./AmazonCommingling.vue?vue&type=template&id=60bf9a81"
import script from "./AmazonCommingling.vue?vue&type=script&lang=js"
export * from "./AmazonCommingling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports